import { createFileRoute } from "@tanstack/react-router";

import { CalendarPage } from "~/features/dashboard/pages/calendar/pages";
import { TabsContent } from "@workspace/web-ui/components/tabs";
import { RefillPage } from "~/features/dashboard/pages/calendar/pages/refills";
import { calendarAppointmentsQueryOptions, calendarRefillsQueryOptions } from "~/features/dashboard/pages/calendar/api/queries";
import { getApiProgram } from "~/lib/utils";
import { bookingRulesExtraQueryOptions, bookingRulesQueryOptions, scheduleQueryOptions } from "~/features/dashboard/pages/calendar/api/settings/queries";

export const Route = createFileRoute("/(dashboard)/dashboard/$program/calendar/")({
  loader: ({ context, params }) => {
    context.queryClient.ensureQueryData(calendarAppointmentsQueryOptions({ program: getApiProgram(params.program) }))
    context.queryClient.ensureQueryData(calendarRefillsQueryOptions({ program: getApiProgram(params.program) }))
    context.queryClient.ensureQueryData(bookingRulesQueryOptions())
    context.queryClient.ensureQueryData(scheduleQueryOptions())
    context.queryClient.ensureQueryData(bookingRulesExtraQueryOptions())
  },
  component: () => (
    <>
      <TabsContent value="consultations">
        <CalendarPage />
      </TabsContent>
      <TabsContent value="appointments">
        <CalendarPage />
      </TabsContent>
      <TabsContent value="medications">
        <RefillPage />
      </TabsContent>
    </>
  ),
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="flex min-h-screen items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-2xl font-bold">Error Loading Calendar Page</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});
